/* eslint-disable no-console */
import {User, UserCredentials} from '../incase-domain/user';
import {httpGet, httpPost, httpPostWithoutIntercept} from './http.service';

export const login = (
    credentials: UserCredentials
): Promise<{
    user?: User;
    errors?: Record<string, string[]>;
}> => {
    return httpPostWithoutIntercept(`admin/auth/loginPlayer`, credentials).then((response) => {
        return {user: response.data};
    });
};

export const fetchLoggedInUser = (): Promise<User | void> => {
    return httpGet(`admin/auth/current`).catch((error) => {
        console.log(error);
    });
};

export const logout = (): Promise<boolean> => {
    return httpPost(`admin/auth/logout`, {});
};
